import gql from "graphql-tag";

const DELETE_PAGE_MUTATION = gql`  
  mutation DeletePage($pageId: String!){
    deletePage(id:$pageId){
      id
    }
  }
`;

export default DELETE_PAGE_MUTATION;
